/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import React from 'react';
import { FormattedMessage, intlShape } from 'react-intl';
import { css, StyleSheet } from 'aphrodite';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { H1, historyShape, locationShape, TSS_DARK_BLUE } from 'tss-core-lib-common';
import IMG_MESSAGE from '../img/mail.svg';
import IMG_PHONE from '../img/contact.svg';
import IMG_REQUEST from '../img/request.svg';
import IMG_USER_GUIDE from '../img/user_guide.svg';
import ContactInfoListContainer from '../containers/ContactInfoListContainer';

let styles;

const ContactInfoPage = ( { tvnId, intl, history, location } ) => (
  <div className={ css( styles.container ) }>
    <div className={ css( styles.helpHeaderContent ) }>
      <div className={ css( styles.helpHeader ) }>
        <h1 className={ css( H1 ) }>
          <FormattedMessage id="module.public.contact.header" />
        </h1>
      </div>
      <div className={ css( styles.helpContent ) }>
        <FormattedMessage id="module.public.contact.content" />
      </div>
    </div>
    <div className={ css( styles.contactInfo ) }>
      { tvnId ? (
        <div className={ css( styles.row ) }>
          <div className={ css( styles.column ) }>
            <div className={ css( styles.leftColumn ) }>
              <img
                src={ IMG_USER_GUIDE }
                className={ css( styles.contactImage ) }
                alt="Contact"
              />
            </div>
          </div>
          <div className={ css( styles.column ) }>
            <div className={ css( styles.rightColumn ) }>
              <div className={ css( styles.contactDetail ) }>
                <NavLink to={ `/?tvnId=${ tvnId }` } className={ css( styles.link ) }>
                  <FormattedMessage id="module.public.back.to.help" />
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      ) : null }
      <div className={ css( styles.row ) }>
        <div className={ css( styles.column ) }>
          <div className={ css( styles.leftColumn ) }>
            <img
              src={ IMG_REQUEST }
              className={ css( styles.contactImage ) }
              alt="Contact"
            />
          </div>
        </div>
        <div className={ css( styles.column ) }>
          <div className={ css( styles.rightColumn ) }>
            <div className={ css( styles.contactDetail ) }>
              <a
                href={ 'https://tss-help.zendesk.com/hc/en-us/requests/new' }
                target={ '_blank' }
                className={ css( styles.link ) }
              >
                <FormattedMessage id="module.public.contact.help.submit.request.details" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className={ css( styles.row ) }>
        <div className={ css( styles.column ) }>
          <div className={ css( styles.leftColumn ) }>
            <img
              src={ IMG_MESSAGE }
              className={ css( styles.contactImage ) }
              alt="Contact"
            />
          </div>
        </div>
        <div className={ css( styles.column ) }>
          <div className={ css( styles.rightColumn ) }>
            <div className={ css( styles.contactDetail ) }>
              <FormattedMessage
                id="module.public.contact.help.mail.details"
                values={ {
                  mail: (
                    <a href="mailto:help@tss.se" className={ css( styles.link ) }>
                      help@tss.se
                    </a>
                  ),
                } }
              />
            </div>
          </div>
        </div>
      </div>

      <div className={ css( styles.row ) }>
        <div className={ css( styles.column ) }>
          <div className={ css( styles.leftColumn ) }>
            <img
              src={ IMG_PHONE }
              className={ css( styles.contactImage ) }
              alt="Contact"
            />
          </div>
        </div>
        <div className={ css( styles.column ) }>
          <div className={ css( styles.rightColumn ) }>
            <div className={ css( styles.contactDetail ) }>
              <FormattedMessage id="module.public.contact.help.call.details" />
            </div>
          </div>
        </div>
      </div>
      <ContactInfoListContainer history={ history } location={ location } intl={ intl } />
    </div>
  </div>
);
ContactInfoPage.propTypes = {
  intl: intlShape.isRequired,
  history: historyShape.isRequired,
  location: locationShape.isRequired,
  tvnId: PropTypes.string,
};

ContactInfoPage.defaultProps = {
  tvnId: null,
};

styles = StyleSheet.create( {
  container: {
    maxWidth: '950px',
    margin: '0 auto 0 auto',
    display: 'flex',
    flexWrap: 'wrap',
  },
  contactInfo: {
    marginLeft: '0.9rem',
    width: '100%',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    height: '5rem',
    marginBottom: '2.3rem',
  },
  column: {
    display: 'flex',
  },
  leftColumn: {
    width: '10rem',
  },
  rightColumn: {
    width: '500px',
  },
  contactDetail: {
    marginTop: '1.6rem',
    marginBottom: '1.6rem',
    fontSize: '1.8rem',
    fontWeight: 400,
    color: TSS_DARK_BLUE,
  },
  helpHeaderContent: {
    marginTop: '2.3rem',
    marginBottom: '2.3rem',
  },
  helpHeader: {
    marginLeft: '0.9rem',
  },
  helpContent: {
    marginLeft: '0.9rem',
    fontSize: '1.8rem',
    fontWeight: 400,
    color: TSS_DARK_BLUE,
  },
  link: {
    textDecoration: 'underline',
  },
  contactImage: {
    width: '5.4rem',
  },
} );

export default ContactInfoPage;



// WEBPACK FOOTER //
// ./src/pages/ContactInfoPage.js